module.exports = __webpack_public_path__ + "img/statistic-subscriptions-block.34d66273.svg";